export default "__VITE_ASSET__2103680a__"